import type { SVGProps } from 'react';

/**
 * Instagram Carousel glyph — replicated verbatim from Figma's custom
 * "24 / Highlight Slides" icon component (node 575:10447, file
 * 0Vugg58oB0iBf1CxP0CUyp). Not a Phosphor icon. Uses `currentColor` to
 * compose with the white-on-gradient-tile treatment it sits in inside
 * deliverable type cards.
 */
export function InstagramCarouselIcon({
  size = 18,
  className,
  weight: _weight,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number; weight?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      {...props}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M6.375 1.5C5.13236 1.5 4.125 2.50736 4.125 3.75V14.25C4.125 15.4926 5.13236 16.5 6.375 16.5H11.625C12.8676 16.5 13.875 15.4926 13.875 14.25V3.75C13.875 2.50736 12.8676 1.5 11.625 1.5H6.375ZM5.625 3.75C5.625 3.33579 5.96079 3 6.375 3H11.625C12.0392 3 12.375 3.33579 12.375 3.75V14.25C12.375 14.6642 12.0392 15 11.625 15H6.375C5.96079 15 5.625 14.6642 5.625 14.25V3.75Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M17.25 5.38156C17.25 4.34845 16.5031 3.46676 15.484 3.29692C15.0344 3.22197 14.625 3.56875 14.625 4.02464V4.14672C14.625 4.43845 14.8117 4.69745 15.0884 4.7897L15.2354 4.83867C15.5427 4.94112 15.75 5.22874 15.75 5.55271V12.4474C15.75 12.7714 15.5427 13.059 15.2354 13.1615L15.0884 13.2105C14.8117 13.3027 14.625 13.5617 14.625 13.8534V13.9755C14.625 14.4314 15.0344 14.7782 15.484 14.7032C16.5031 14.5334 17.25 13.6517 17.25 12.6186V5.38156Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0.5625 5.38156C0.5625 4.34845 1.3094 3.46676 2.32846 3.29692C2.77814 3.22197 3.1875 3.56875 3.1875 4.02464V4.14672C3.1875 4.43845 3.00082 4.69745 2.72407 4.7897L2.57715 4.83867C2.26981 4.94112 2.0625 5.22874 2.0625 5.55271V12.4474C2.0625 12.7714 2.26981 13.059 2.57715 13.1615L2.72407 13.2105C3.00082 13.3027 3.1875 13.5617 3.1875 13.8534V13.9755C3.1875 14.4314 2.77814 14.7782 2.32846 14.7032C1.3094 14.5334 0.5625 13.6517 0.5625 12.6186V5.38156Z" fill="currentColor" />
    </svg>
  );
}
